import styled from '@emotion/styled/macro'

import { flexCenter, pageContentDefaultSize } from 'style/emotion'
import mediaQuery from 'share/utils/mediaQuery'

const ClientLevelDashContainer = styled('section')`
  ${pageContentDefaultSize}

  > h2 {
    margin-bottom: 24px;
    margin-top: 48px;

    ${mediaQuery('tablet')} {
      margin-top: 24px;
    }
  }
`

const CardsWrapper = styled('div')`
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  width: inherit;

  & .badge {
    background-color: var(--CINight-10);
    border: 1px solid var(--gray-1);
    color: var(--CINight);
    font-weight: 400;
    padding: 4px 8px;
  }

  & .ui-go-to-case-btn {
    width: 100%;
  }

  > .card {
    border-radius: 3px;
    box-shadow: 2px 2px 2px 0px var(--gray-2);
    -webkit-box-shadow: 2px 2px 2px 0px var(--gray-2);
    flex-basis: 100%;
    padding: 20px;

    .cases-deactivate-case {
      font-size: 12px;
    }

    :not(:first-of-type) {
      margin-top: 16px;
    }

    ${mediaQuery('', 'tablet')} {
      flex-basis: calc(50% - 8px);

      :nth-of-type(even) {
        margin-left: 16px;
      }

      :nth-of-type(-n + 2) {
        margin-top: 0;
      }
    }
  }
`

const ShowDeactivatedBtnContainer = styled('div')`
  ${flexCenter}

  height: auto;

  > button {
    font-size: 0.75rem;
    margin-top: 24px;
  }
`

export { CardsWrapper, ClientLevelDashContainer, ShowDeactivatedBtnContainer }
